import React from 'react';

const RichText = (props: { text: string }) => {
  return (
    <div className="rich-text" dangerouslySetInnerHTML={ { __html: props.text } }/>
  );
};

export default RichText;
